import React from "react";
import { Grid, Typography, IconButton, Box } from "@mui/material";
import { Group, GroupAdd, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const navigate = useNavigate();

  const username = useSelector(
    (state) => state?.ProfileSettingsReducer?.profiledetails?.user_name
  );

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        py: 5,
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          width: "90%",
          mx: "auto",
          borderRadius: 2,
          p: 5,
          boxShadow: 1,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", mb: 6, color: "black" }}
        >
          Welcome back, {username || "User"}
        </Typography>

        {/* Create Group */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            borderBottom: "1px solid #e0e0e0",
            py: 4,
            cursor: "pointer",
          }}
        >
          <Grid item sx={{ display: "flex", alignItems: "center" }}>
            <Group sx={{ fontSize: 40, color: "black", mr: 2 }} />
            <Box sx={{ textAlign: "left" }}>
              <Typography variant="h6" sx={{ color: "black", fontWeight: 500 }}>
                Create Group
              </Typography>
              <Typography variant="body2" sx={{ color: "black" }}>
                Control the ride policies and travel budgets for your employees
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleNavigate("/corporate_group")}>
              <ArrowForwardIos sx={{ color: "black" }} />
            </IconButton>
          </Grid>
        </Grid>

        {/* Add Employees */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            py: 4,
            cursor: "pointer",
          }}
        >
          <Grid item sx={{ display: "flex", alignItems: "center" }}>
            <GroupAdd sx={{ fontSize: 40, color: "black", mr: 2 }} />
            <Box sx={{ textAlign: "left" }}>
              <Typography variant="h6" sx={{ color: "black", fontWeight: 500 }}>
                Add Employees
              </Typography>
              <Typography variant="body2" sx={{ color: "black" }}>
                Empower your employees to book official rides
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleNavigate("/corporate_employee")}>
              <ArrowForwardIos sx={{ color: "black" }} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
